import { requests } from '../../agent/agent';

export const GeolocationApi = {
    getCords: (address: string): Promise<any> => requests.get(`/geolocation`, { address: address }),
};
